
import "./ClientInfo.css";
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { findClientById } from "../../api";
import { useGlobalContext } from "../../context";
import { downloadFile } from "../AllClients/AllClientsTable";
import Header from "../../Components/Header/Header";
import ClientImages from "./ClientImages";
import DeleteClient from "./Delete";
import DeleteIcon from '@mui/icons-material/Delete';
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded';
import NoteAddRoundedIcon from '@mui/icons-material/NoteAddRounded';
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";

function ClientInfo() {

    const {
        concretClient,
        setConcretClient
    } = useGlobalContext()

    const location = useLocation();
    const navigate = useNavigate();
    const [client, setClient] = useState<any>();
    const [openDelete, setOpenDelete] = useState<boolean>(false);

    const getClientInfo = async (): Promise<void> => {
        const clientInfo = await findClientById(location.state);
        if (clientInfo) {
            setClient(clientInfo.data);
        }
    }

    useEffect(() => {
        getClientInfo().then(r => r);
    }, [location.state])

    const goToEditPage = (): void => {
        navigate("/edit-client", { state: { id: client.id } })
    }

    return(
        client &&
        <div className = "ClientInfo">
            <Header/>
            <span
                className = "clientInfoArrowBox">
                <KeyboardArrowLeftIcon
                    style = {{
                        color: "#004DE7"
                    }}
                    onClick = { () => window.history.back() }
                />
            </span>
            <div className = "clientInfoHeaderAndBtnsBox">
                <h2>CLIENT INFO</h2>
                <span>
                    <DeleteIcon
                        className = "client-info-icon"
                        onClick = {() => {
                            setOpenDelete(true);
                            setConcretClient(client);
                        }}
                    />
                    <BorderColorRoundedIcon
                        className = "client-info-icon"
                        onClick = { goToEditPage }
                    />
                    <NoteAddRoundedIcon
                        className = "client-info-icon"
                        onClick = { () => downloadFile(client) }
                    />
                </span>
            </div>
            {
                <div className="ClientInfoPageMainBox">
                    <div className="ClientInfoPageRowBox">
                        <span className="clientInfoSpan">
                            <p className="clientInfoTitleText">Package</p>
                            <p className="clientInfoDataText">{ client.packageName }</p>
                        </span>
                        <span className="clientInfoSpan">
                            <p className="clientInfoTitleText">Account Manager</p>
                            <p className="clientInfoDataText">{ client.accountManagerName }</p>
                        </span>
                        <span className="clientInfoSpan">
                            <p className="clientInfoTitleText">Full Name</p>
                            <p className="clientInfoDataText">{ client.firstName + " " + client.lastName }</p>
                        </span>
                        {
                            client.businessData?.companyName &&
                                <span className="clientInfoSpan">
                                    <p className="clientInfoTitleText">Company name</p>
                                    <p className="clientInfoDataText">{ client.businessData.companyName }</p>
                                </span>
                        }
                        {
                            client?.businessData?.brokerageName &&
                                <span className="clientInfoSpan">
                                    <p className="clientInfoTitleText">Brokerage Name</p>
                                    <p className="clientInfoDataText">{ client.businessData.brokerageName }</p>
                                </span>
                        }
                        <span className="clientInfoSpan">
                            <p className="clientInfoTitleText">Phone Number</p>
                            {
                                client.phoneNumbers.map((item: any) =>
                                    <p className="clientInfoDataText">
                                        <p className="clientInfoTypeText">
                                            { item.key }
                                        </p>
                                        { item.value }
                                    </p>
                                )
                            }
                        </span>
                        <span className="clientInfoSpan">
                            <p className="clientInfoTitleText">Email</p>
                            {
                                client.emails?.map((email: string) =>
                                    <p className = "clientInfoDataText">
                                        { email }
                                    </p>
                                )
                            }
                        </span>
                        {
                            client.address &&
                                <span className="clientInfoSpan">
                                    <p className="clientInfoTitleText">Address</p>
                                    <p className="clientInfoDataText">{ client.address }</p>
                                </span>
                        }
                        <span className="clientInfoSpan">
                            <p className="clientInfoTitleText">Do you want to include your address on your brandings?</p>
                            <p className="clientInfoDataText">{ client.includeAddressOnBranding ? "Yes" : "No" }</p>
                        </span>
                        <span className="clientInfoSpan">
                            <p className="clientInfoTitleText">Business Type</p>
                            <p className="clientInfoDataText">{ client.businessData.businessType }</p>
                        </span>
                        {
                            client.businessData.businessSubtype &&
                            <span className="clientInfoSpan">
                                <p className="clientInfoTitleText">Business Category</p>
                                <p className="clientInfoDataText">{ client.businessData.businessSubtype }</p>
                            </span>
                        }
                        <span className="clientInfoSpan">
                            <p className="clientInfoTitleText">Term to be used for { client.businessData.businessType }</p>
                            <p className="clientInfoDataText">{ client.businessData.termForBusiness }</p>
                        </span>
                        {
                            client.businessData.businessType === "Mortgage" &&
                                <span className="clientInfoSpan">
                                    <p className="clientInfoTitleText">Equal Housing Logo</p>
                                    <p className="clientInfoDataText">{ client.businessData.mortgageLogo }</p>
                                </span>
                        }
                        {
                            client.businessData.noun &&
                                <span className="clientInfoSpan">
                                    <p className="clientInfoTitleText">Which noun would you like to use for your marketing materials?</p>
                                    <p className="clientInfoDataText">{ client.businessData.noun }</p>
                                </span>
                        }
                    </div>
                    <div className="ClientInfoPageRowBox">
                        {
                            client.websites[0].length > 0 &&
                                <span className="clientInfoSpan">
                                    <p className="clientInfoTitleText">Website</p>
                                    {
                                        client.websites?.map((web: string) =>
                                            <p className="clientInfoDataText">
                                                { web }
                                            </p>
                                        )
                                    }
                                </span>
                        }
                        {
                            client.businessData?.licenseNumbers[0]?.length > 0 &&
                                <span className="clientInfoSpan">
                                    <p className="clientInfoTitleText">License Number</p>
                                    {
                                        client.businessData?.licenseNumbers?.map((number: string) =>
                                            <p className="clientInfoDataText">
                                                { number }
                                            </p>
                                        )
                                    }
                                </span>
                        }
                        {
                            client.additionalData?.facebookProfileId &&
                                <span className="clientInfoSpan">
                                    <p className="clientInfoTitleText">Facebook ID</p>
                                    <p className="clientInfoDataText">{ client.additionalData.facebookProfileId }</p>
                                </span>
                        }
                        {
                            client.additionalData?.instagramProfileId &&
                                <span className="clientInfoSpan">
                                    <p className="clientInfoTitleText">Instagram ID</p>
                                    <p className="clientInfoDataText">{ client.additionalData.instagramProfileId }</p>
                                </span>
                        }
                        {
                            client.additionalData?.accessToken &&
                                <span className="clientInfoSpan">
                                    <p className="clientInfoTitleText">Access Token</p>
                                    <p className="clientInfoDataText">{ client.additionalData.accessToken }</p>
                                </span>
                        }
                        {
                            client.additionalData?.socialMediaList?.length > 0 &&
                                <span className="clientInfoSpan">
                                    <p className="clientInfoTitleText">Social Media</p>
                                    {
                                        client.additionalData?.socialMediaList?.map((item: any) =>
                                            <p className="clientInfoDataText">
                                                <p className="clientInfoTypeText">
                                                    { item.key }
                                                </p>
                                                { item.value }
                                            </p>
                                        )
                                    }
                                </span>
                        }
                        {
                            client.additionalData?.hashtags?.length > 0 &&
                                <span className="clientInfoSpan">
                                    <p className="clientInfoTitleText"># Hashtag</p>
                                    <p className="clientInfoDataText">{ client.additionalData.hashtags }</p>
                                </span>
                        }
                        {
                            client.additionalData?.additionalNotes?.length > 0 &&
                                <span className="clientInfoSpan">
                                    <p className="clientInfoTitleText">Additional Notes</p>
                                    <p className="clientInfoDataText">{ client.additionalData.additionalNotes }</p>
                                </span>
                        }
                        {
                            client.additionalData?.leadBy?.length > 0 &&
                                <span className="clientInfoSpan">
                                    <p className="clientInfoTitleText">Lead By</p>
                                    <p className="clientInfoDataText">{ client.additionalData.leadBy }</p>
                                </span>
                        }
                        {
                            client.additionalData?.soldBy?.length > 0 &&
                                <span className="clientInfoSpan">
                                    <p className="clientInfoTitleText">Sold By</p>
                                    <p className="clientInfoDataText">{ client.additionalData.soldBy }</p>
                                </span>
                        }
                    </div>
                </div>
            }
            <ClientImages
                client = { client }
            />
            {
                concretClient &&
                    <DeleteClient
                        concretClient = { concretClient }
                        setConcretClient = { setConcretClient }
                        openDelete = { openDelete }
                        setOpenDelete = { setOpenDelete }
                    />
            }
        </div>
    )
}

export default ClientInfo
